<template>
  <div>
    <div>
      <div class="d-t-w">
        <div class="text-left">标签名称</div>
        <div class="c-i">
          <el-input size="small" placeholder="请输入名称" v-model="name" />
        </div>
      </div>
      <div class="d-t-w m-d">
        <div class="text-left">图片</div>
        <div class="u-w c-i-u">
          <el-upload
            :on-success="handleAvatarSuccess"
            :data="uploadData"
            class="avatar-uploader"
            :action="action"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let ossResultProxy = null;
import OssUpload from "../../../common/OssUpload";

export default {
  name: "OssUploadExample",

  components: {},

  props: {},

  data() {
    return {
      uploadData: {},
      action: "",
      imageUrl: null,
      name: "",
      objectKey: "",
      id:0,
    };
  },
  computed: {},
  mounted() {
    // this.$store.dispatch('getHomeData')
  },

  methods: {
    setValue(obj) {
      this.name = obj.name
      this.imageUrl = obj.imgUrl
      this.objectKey = obj.objectKey;
      this.id=obj.id
    },
    handleAvatarSuccess(response) {
      this.imageUrl = ossResultProxy.url;
      this.objectKey = ossResultProxy.objectKey;
      this.$emit("uploadSuccess", { url: this.imageUrl, name: this.name,objectKey: this.objectKey  });
    },

    async beforeAvatarUpload(file) {
      let ossUpload = new OssUpload();

      let ossResult = await ossUpload.getElOssPolicy(2);
      console.info(ossResult);

      this.action = ossResult.host;
      this.uploadData = ossResult.uploadData;
      ossResultProxy = ossResult;
      return true;
    },
  },
};
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 128px;
  height: 128px;
  line-height: 128px;
  text-align: center;
}

.avatar {
  width: 128px;
  height: 128px;
  display: block;
}
.d-t-w {
  display: flex;
  align-items: center;
}
.u-w {
  border: 1px solid #ffd04b;
}
.c-i {
  margin-left: 12px;
}
.c-i-u {
  margin-left: 36px;
}
.m-d {
  margin-top: 20px;
}
.text-left {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/main/admin/component/TagImgUpload.vue